export default __webpack_public_path__ + "static/media/claimSupportbg.e770a6d9.svg";